import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Home = ({ fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.tab.default;

  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.125 19.5V6.83333L9.125 0.5L18.125 6.83333V19.5H11.375V12.1111H6.875V19.5H0.125Z"
        fill={fill}
      />
    </svg>
  );
};
